<script setup lang="ts">
import { useI18n } from '@/plugins/i18n';
import { useSearchStore } from '../../store/index.ts';
import CrossReferenceSuggest from '@/components/Search/CrossReferenceSuggest.ce.vue';
import FilterDropdown from '@/components/Search/FilterDropdown.ce.vue';
import CategoriesFilter from '@/components/Search/SearchFilters/Common/CategoriesFilter/index.ce.vue';

import iconStatus from '@/assets/img/icon-search-all-filters-status.svg';
import iconPublisher from '@/assets/img/icon-search-all-filters-publisher.svg';
import iconSearchIn from '@/assets/img/icon-search-all-filters-search-in.svg';
import iconCountry from '@/assets/img/icon-search-all-filters-country.svg';
import iconDataset from '@/assets/img/icon-search-all-filters-dataset.svg';
import iconLanguage from '@/assets/img/icon-search-all-filters-language.svg';
import iconYear from '@/assets/img/icon-search-all-filters-year.svg';
import { STANDARDS_SEARCH_TAB } from '@/components/Search/constants.ts';

//store
const searchStore = useSearchStore()
const { getItem } = searchStore

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance
</script>

<template>
    <div class="all-filters-body">
        <div class="filter-item cross-reference">
            <CrossReferenceSuggest
            v-model="searchStore['standards.crossReference']"
            :placeholder="t('crossReferencePlaceHolder')"
            :matchInputWidth="true"
            :useFixedOverlay="false"
            :invertClearOnBlur="false"
            overlayPlacement="full"
            inputClass="crossref-input crossref-input--modal"
            />
        </div>
        <div class="filter-item search-in">
            <FilterDropdown
            className="accordion"
            :placeholder="t('searchIn')"
            name="searchIn"
            :multiple="false"
            :field="`${STANDARDS_SEARCH_TAB}.searchIn`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.searchIn`"
            :hasClear="false"
            :iconMain="iconSearchIn"
            :iconOpenMain="iconSearchIn"
            :searchable="false"
            :translate="true" />
        </div>
        <div class="filter-item status">
            <FilterDropdown
            className="accordion"
            :placeholder="t('status')"
            name="status"
            :multiple="true"
            :field="`${STANDARDS_SEARCH_TAB}.status`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.status`"
            :hasClear="false"
            :iconMain="iconStatus"
            :iconOpenMain="iconStatus"
            :searchable="false" />
        </div>
        <div class="filter-item publisher">
            <FilterDropdown
            className="accordion"
            :placeholder="t('publisher')"
            :searchPlaceholder="t('searchPublisherPlaceholder')"
            name="publisher[]"
            :multiple="true"
            :field="`${STANDARDS_SEARCH_TAB}.publisher`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.publisher`"
            :searchable="true"
            :hasClear="false"
            :initialOptions="getItem('standards.publisher')"
            :iconMain="iconPublisher"
            :iconOpenMain="iconPublisher"
            :loadOptionsOnClick="true"
            />
        </div>
        <div class="filter-item country">
            <FilterDropdown
            className="accordion"
            :placeholder="t('country')"
            name="country"
            :multiple="false"
            :field="`${STANDARDS_SEARCH_TAB}.country`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.country`"
            :hasClear="false"
            :iconMain="iconCountry"
            :iconOpenMain="iconCountry"
            :searchable="true"
            :loadOptionsOnClick="true" />
        </div>
        <div class="filter-item dataset">
            <FilterDropdown
            className="accordion"
            :placeholder="t('dataset')"
            name="dataset"
            :multiple="false"
            :field="`${STANDARDS_SEARCH_TAB}.dataset`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.dataset`"
            :hasClear="false"
            :iconMain="iconDataset"
            :iconOpenMain="iconDataset"
            :searchable="false" />
        </div>
        <div class="filter-item categories">
            <CategoriesFilter :searchType="STANDARDS_SEARCH_TAB" :useTeleport="false"></CategoriesFilter>
        </div>
        <div class="filter-item language">
            <FilterDropdown
            className="accordion"
            :placeholder="t('language')"
            name="language"
            :multiple="true"
            :field="`${STANDARDS_SEARCH_TAB}.language`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.language`"
            :hasClear="false"
            :iconMain="iconLanguage"
            :iconOpenMain="iconLanguage"
            :searchable="false"
            :translate="true"/>
        </div>
        <div class="filter-item year">
            <FilterDropdown
            className="accordion"
            :placeholder="t('year')"
            name="year"
            :multiple="true"
            :field="`${STANDARDS_SEARCH_TAB}.year`"
            :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.year`"
            :hasClear="false"
            :iconMain="iconYear"
            :iconOpenMain="iconYear"
            :searchable="false" />
        </div>
    </div>
</template>
